export default "<router-outlet>\n    <app-spinner></app-spinner>\n    <app-notifications></app-notifications>\n</router-outlet>";